import './App.scss';
import Landing from './components/landing/Landing.js';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Rocks from './components/ungraduated/Rocks.js';
import Chart from './components/chart/Chart.js';
import Createnewtoken from './components/Createnewtoken/Createnewtoken.js';
import Navbar from './components/landing/header/Navbar.js';
import Createnewnetwork from './components/createnewnetwork/Createnewnetwork.js';
import Gems from './components/graduated/Gems.js';


function App() {
  return (
    <>
      <ToastContainer style={{ fontSize: 20 }} />
      <Router>
        {/* <Navbar/> */}
        <Switch>
          <Route exact path='/' component={Landing} />
          <Route exact path='/Names' component={Rocks} />
          <Route exact path='/coin/:id' component={Chart} />
          <Route exact path='/createnetwork' component={Createnewtoken} />
          <Route exact path='/createnewnetwork' component={Createnewnetwork} />
          <Route exact path='/Vip' component={Gems} />
        </Switch>
      </Router>
    </>
  );
}

export default App;
